import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'cesion',
  type: 'node--cesion',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    descripcion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'descripcion',
    },
    fechaCesion: {
      type: 'date',
      required: false,
      isArray: false,
      name: 'fecha_cesion',
    },
    fechaDevolucion: {
      type: 'date',
      required: false,
      isArray: false,
      name: 'fecha_devolucion',
    },
    honorarios: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'honorarios',
    },
    importe: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'importe_inversion',
    },
    interes: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'interes',
    },
  },
  relationships: {
    contrato: {
      type: 'node--document',
      required: false,
      isArray: false,
      name: 'contrato',
    },
    inversor: {
      type: 'node--inversor',
      required: false,
      isArray: false,
      name: 'inversor',
    },
    letras: {
      type: 'node--instancia_letra_cesion',
      required: false,
      isArray: true,
      name: 'letras_cesion',
    },
  },
};
export const CesionService = createService(base, configuration, API_CONFIG.API);
export const CesionModule = createModule(CesionService, true);



// WEBPACK FOOTER //
// ./src/models/cesion.js